import * as React from 'react';

import { styled } from '@mui/material';
import Box, { BoxProps } from '@mui/material/Box';

export type InstagramTagProps = {
  username?: string | null;
  textColor?: string;
  customFontSize?: string;
  showAtSign?: boolean;
} & BoxProps;

export const InstaLink = styled(Box)<{
  target?: string;
  href?: string;
  textColor?: string;
  customFontSize?: string;
}>(({ textColor, customFontSize }) => ({
  color: textColor || '#0C66E4',
  fontSize: customFontSize || '14px',
  textDecoration: 'none',
  ':hover': {
    textDecoration: 'underline',
  },
}));

const InstagramTag: React.FC<InstagramTagProps> = ({ username, showAtSign = true, ...restProps }) => {
  return (
    username && (
      <InstaLink
        component='a'
        target='_blank'
        href={`https://instagram.com/${username}`}
        {...restProps}
      >
        {showAtSign ? `@${username}` : username}
      </InstaLink>
    )
  );
};

export default InstagramTag;
